import { z } from 'zod'
import { trainerOpsNotificationSummarySchema } from './trainer-ops-read'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

export const trainerNotificationReadRequestSchema = z.object({}).passthrough()

export const trainerNotificationReadResponseSchema = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
  notification: trainerOpsNotificationSummarySchema,
  sideEffects: z.object({
    db1Written: z.literal(true),
    auditWritten: z.literal(true),
  }).passthrough(),
}).passthrough()

export type TrainerNotificationReadRequest = z.infer<typeof trainerNotificationReadRequestSchema>
export type TrainerNotificationReadResponse = z.infer<typeof trainerNotificationReadResponseSchema>
